import { Card, Form, Input, Button, Switch, message, Divider } from 'antd';
import { SaveOutlined } from '@ant-design/icons';

export function SettingsPage() {
  const [form] = Form.useForm();

  const handleSubmit = (values: any) => {
    console.log('Settings values:', values);
    message.success('Paramètres sauvegardés');
  };

  return (
    <div className="space-y-4 sm:space-y-6">
      <h1 className="text-xl sm:text-2xl font-semibold text-neutral-900">Paramètres</h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 sm:gap-6">
        {/* General Settings */}
        <Card title="Paramètres généraux">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
            initialValues={{
              appName: 'Tunisie Parking Admin',
              timezone: 'Africa/Tunis',
              language: 'fr-TN',
              notifications: true,
            }}
          >
            <Form.Item
              name="appName"
              label="Nom de l'application"
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="timezone"
              label="Fuseau horaire"
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="language"
              label="Langue"
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="notifications"
              label="Notifications"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Sauvegarder
            </Button>
          </Form>
        </Card>

        {/* Security Settings */}
        <Card title="Sécurité">
          <Form layout="vertical">
            <Form.Item
              name="sessionTimeout"
              label="Timeout de session (minutes)"
            >
              <Input type="number" defaultValue={30} />
            </Form.Item>

            <Form.Item
              name="maxLoginAttempts"
              label="Tentatives de connexion max"
            >
              <Input type="number" defaultValue={5} />
            </Form.Item>

            <Form.Item
              name="require2FA"
              label="Authentification à deux facteurs"
              valuePropName="checked"
            >
              <Switch />
            </Form.Item>

            <Divider />

            <div className="space-y-2">
              <h4 className="font-medium text-neutral-900">Actions de sécurité</h4>
              <Button type="default" className="w-full">
                Réinitialiser les sessions
              </Button>
              <Button type="default" className="w-full">
                Exporter les logs
              </Button>
              <Button danger className="w-full">
                Vider le cache
              </Button>
            </div>
          </Form>
        </Card>

        {/* System Info */}
        <Card title="Informations système" className="lg:col-span-2">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="text-center p-4 bg-neutral-50 rounded-lg">
              <div className="text-2xl font-bold text-primary-500">v1.0.0</div>
              <div className="text-sm text-neutral-600">Version</div>
            </div>
            <div className="text-center p-4 bg-neutral-50 rounded-lg">
              <div className="text-2xl font-bold text-success-500">99.9%</div>
              <div className="text-sm text-neutral-600">Uptime</div>
            </div>
            <div className="text-center p-4 bg-neutral-50 rounded-lg">
              <div className="text-2xl font-bold text-warning-500">2.1s</div>
              <div className="text-sm text-neutral-600">Temps de réponse</div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
}
